import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { ActivationStartContainer } from '@/components/pages/Activation/Start';

export const ActivationStartPage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.activation.start.title');

  return (
    <PageRootWrapper
      title={title}
      headerTitle={t('text.activation.start.prompt')}
      breadcrumbItems={[{ label: t('text.activation.start.prompt') }]}
      containerType="normal"
    >
      <p className="message">
        {t('text.activation.start.attention')}
        <br />
        {t('text.activation.start.request')}
      </p>
      <ActivationStartContainer />
    </PageRootWrapper>
  );
};
